import Link from 'next/link'
import { memo } from 'react'
import { scrollToTabs } from '../../product-page.utils'

import './product-description.scss'

type Props = {
  title: string
  description: string[]
  pathname: string
  linkText: string
}

const ProductDescription = ({ title, description, pathname, linkText }: Props) => {
  const fullDescriptionLink = pathname + '?tab=description'

  return (
    <section className="product-description">
      <h2 className="h4">{title}</h2>
      <div data-testid="product-description-list" className="list">
        <ul>
          {description.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      </div>
      <Link
        onClick={scrollToTabs}
        data-testid="product-description-view-all-link"
        scroll={false}
        href={fullDescriptionLink}>
        {linkText}
      </Link>
    </section>
  )
}

export default memo(ProductDescription)
